module.exports = new __parcel__URL__("logo_vannes.6a3c969f.jpg").toString();